<template>
  <swiper ref="ref" class="swiper" v-bind="$attrs" v-on="$listeners">
    <slot />
    <div v-if="data.length > 1" slot="pagination" class="swiper-pagination"></div>
    <div v-if="data.length > 1" slot="button-prev" class="swiper-button-prev"></div>
    <div v-if="data.length > 1" slot="button-next" class="swiper-button-next"></div>
  </swiper>
</template>
<style lang="scss" scoped></style>
<script>
import { Swiper } from "vue-awesome-swiper";
import { BaseComponent } from "@/components/base-component";
import "swiper/swiper.min.css";

export default {
  name: "Siper",
  components: {
    Swiper,
  },
  extends: BaseComponent,
  props: {
    data: { type: Array, default: () => [] },
    backgroudMode: {
      type: String,
      default: "style",
      validator: mode => ["style", "image"].indexOf(mode) != -1,
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.ref.updateSwiper();
    });
  },
  methods: {
    autoplayStart() {
      this.$refs.ref.$swiper.autoplay.start();
    },
    autoplayStop() {
      this.$refs.ref.$swiper.autoplay.stop();
    },
  },
};
</script>
